import { z } from 'zod';
import { dateParser, guestLinkStatusParser } from '#validation';
import { memberRefSchema } from '#web-service-api/member';
export const GuestLinkBaseResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    filespaceId: z.string(),
    workspaceId: z.string(),
    fsEntryId: z.string(),
    createdByMemberId: z.string(),
    createdByMember: memberRefSchema.nullish(),
    status: guestLinkStatusParser,
    expiresAt: dateParser().nullable(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    eInvitationSecretByAdminKey: z.string(),
});
